import * as types from './actionTypes';
import authApi from '../api/authApi';
import {beginAjaxCall} from './ajaxStatusActions';

export function loginSuccess(me) {
    return {type: types.AUTH_LOGIN_SUCCESS, me};
}

export function loginFailure(error) {
    return {type: types.AUTH_LOGIN_FAILURE, error};
}

export function getCurrentUserSuccess(user) {
    return {type: types.AUTH_GET_CURRENT_USER_SUCCESS, user};
}

export function logoutSuccess() {
    return {type: types.AUTH_LOGOUT};
}

export function login(credentials) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return authApi.login(credentials).then(response => {
            localStorage.setItem('me', JSON.stringify(response));
            dispatch(loginSuccess(response));
            return Promise.resolve(response);
        },(response)=> {
            return Promise.reject(response.error);
        });
    };
}

export function getCurrentUser() {
    return function (dispatch) {
        let me = localStorage.getItem('me');
        me = JSON.parse(me);
        if(me!=null) dispatch(getCurrentUserSuccess(me));
    };
}

export function logout() {
    return function (dispatch) {
        localStorage.removeItem('me');
        dispatch(logoutSuccess());
    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/authAction.js
 **/